// extracted by mini-css-extract-plugin
export var dateLabel = "_3s-0";
export var dateLabelError = "_3s-1";
export var fullWidth = "_3s-2";
export var smaller = "_3s-3";